import { resetParsleyFor, selectOptionFor } from "./inputs_utils";

export const resetForm = (form) => {
  form.reset();
  resetParsleyFor(form);
  resetSelect2Inputs(form);
  resetFlatpickrs(form);
  resetSubmitBtn(form);
};

const resetFlatpickrs = (form) => {
  form.querySelectorAll("input.flatpickr-input").forEach((input) => {
    input._flatpickr.setDate(input.dataset.initialValue, true);
  });
};

const resetSelect2Inputs = (form) => {
  const select2Inputs = form.querySelectorAll("[data-controller='select2']");
  select2Inputs.forEach((input) => selectOptionFor(input, input.dataset.initialValue));
};

const resetSubmitBtn = (form) => {
  const submitBtn = form.querySelector('input[type="submit"]');
  if (!submitBtn) return;

  submitBtn.disabled = false;
};
